import React from 'react'
import { amtNumStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  documentListing?: any
  mode?: string
}

export const UsefulLifeDetailContent = (props: DetailProps) => {
  let history = useHistory()
  const { CompanyID }: any = useParams()
  const { listEl, documentListing, listStatus, userList, mode } = props
  const [openDoc, setOpenDoc] = useState<boolean>(false)
  const { menu } = useMenuOption()

  return (
    <>
      <div className="content-wrap left">
        <div className="desc " style={{ color: 'grey' }}>
          {`Start Date`}
        </div>
        <div className="mdDesc text-noflow">{formatDate(listEl?.Date)}</div>
      </div>
      <div className="content-wrap right">
        <div className="desc " style={{ color: 'grey' }}>
          {`Model No.`}
        </div>
        <div className="mdDesc text-noflow">{listEl?.ModelNo}</div>
      </div>
      <div className="content-wrap left">
        <div className="desc " style={{ color: 'grey' }}>
          {`Submitted By`}
        </div>
        <div className="mdDesc text-noflow">{listEl?.SubmittedBy}</div>
      </div>
      <div className="content-wrap right">
        <div className="desc " style={{ color: 'grey' }}>
          {`Submitted Date`}
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listEl?.SubmittedDate)}
        </div>
      </div>
      <div className="content-wrap left">
        <div className="desc " style={{ color: 'grey' }}>
          {`Approved By`}
        </div>
        <div className="mdDesc text-noflow">{listEl?.ApprovedBy}</div>
      </div>
      <div className="content-wrap right">
        <div className="desc " style={{ color: 'grey' }}>
          {`Approved Date`}
        </div>
        <div className="mdDesc text-noflow">
          {formatDate(listEl?.ApprovedDate)}
        </div>
      </div>
    </>
  )
}
